import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import RowClick from '../../../../common/RowClick';
import Table from '../../../../common/table/Table';
import TextBlink from '../../../../common/table/TextBlink';
import { getColorPrice } from '../../../../helpers/Color';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../../helpers/Text';
import CellHover from '../../../../market/watchlist/summary/CellHover';
import { cellNegtiveRed } from '../../../../common/table/CustomCellTable';
import '../../../technical.scss';
import { REDUCER_NAME } from '../reducer';
import Const from './Const';
import { I18n } from 'react-redux-i18n';
import TradingViewUrl from '../../../../common/TradingViewUrl';
import { compose } from 'redux';

class TableCancelled extends React.PureComponent {
  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectDeceptiveCancelledDataByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.REF_PRICE),
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      'text',
    );
  };

  handleScroll = e => {
    const { totalPage, onLoadMore, page } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page >= totalPage) return;
    if (bottom) {
      onLoadMore(page + 1);
    }
  };

  getThTooltip = key => {
    const mapKey = {
      [Const.listColumn.NR_CO]: I18n.t('table.technical.nrOfCo'),
      [Const.listColumn.VOL_CO]: I18n.t('table.technical.volOfCo'),
      [Const.listColumn.NR_CO_BUY]: I18n.t('table.technical.nrOfCoBuy'),
      [Const.listColumn.NR_CO_SELL]: I18n.t('table.technical.nrOfCoSell'),
      [Const.listColumn.VOL_CO_BUY]: I18n.t('table.technical.volOfCoBuy'),
      [Const.listColumn.VOL_SELL]: I18n.t('table.technical.volOfCoSell'),
    };

    return mapKey[key];
  };

  schema = (listColumn, i18nTitleKey) =>
    Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          thStyle: { width: '40px' },
          render: (text, item) => (
            <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
              <TextBlink item={item} tradingDate="tradingDate">
                <TradingViewUrl code={item.organCode} />
                &nbsp;{text}
              </TextBlink>
            </CellHover>
          ),
        };
      }

      if (_.includes([listColumn.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [
            listColumn.VOLUME,
            listColumn.VOL_CO,
            listColumn.VOL_CO_BUY,
            listColumn.VOL_SELL,
          ],
          key,
        )
      ) {
        return {
          ...result,
          thTooltip: this.getThTooltip(key),
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {cellNegtiveRed(formatTextFloat(formatVolume(text)))}
              </TextBlink>
            );
          },
        };
      }

      return {
        ...result,
        thTooltip: this.getThTooltip(key),
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {formatTextFloat(text, 0)}
          </TextBlink>
        ),
      };
    });

  render() {
    const { isLoading, onSort, ids, scrollRef } = this.props;
    if (ids.length === 0 && !isLoading) {
      return (
        <div className="empty-data-msg text-s-color-3">
          {I18n.t('tasignals.deceptiveDataMessage.noDataForFilter')}
        </div>
      );
    }
    return (
      <RowClick>
        {onRowClick => (
          <Table
            onSort={onSort}
            clickRow={onRowClick}
            thValign="top"
            isLoading={isLoading}
            ids={ids}
            resizable={true}
            scrollRef={scrollRef}
            columnDraggable={false}
            rowDraggable={false}
            onScrollFunction={this.handleScroll}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            isShowHeadLoading={true}
            schema={this.schema(Const.listColumn, 'tasignals.cancelledHeader')}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listDeceptiveCancelledDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TableCancelled);
